<template>
  <g v-if="color">
    <path
      v-for="(path, index) in group"
      :key="index"
      :d="path"
      v-bind:style="{ fill: color.hex }"
    ></path>
  </g>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "SVGGroup",
  props: {
    design: {
      type: Object
    },
    groupIndex: {
      type: Number
    },
    side: {
      type: String
    }
  },
  computed: {
    ...mapGetters('project', ['color1', 'color2', 'color3']),
    group() {
      return this.design.svg_data && this.design.svg_data[this.side][`group${this.groupIndex}`] ? this.design.svg_data[this.side][`group${this.groupIndex}`] : [];
    },
    color() {
      return this[`color${this.groupIndex}`]
    },
  }
}
</script>